
<template>
  <!--编辑产品功能-->
  <div class="advanced-form">
    <div class="card">
      <div class="card-head">
        <h3>功能定义</h3>
      </div>
      <div class="card-body">
        <a-button @click="openAddModal" type="primary" :style="{marginBottom: '24px'}">添加功能</a-button>

        <x-tabula
          ref="table"
          rowKey="action_id"
          :getList="getList"
          :columns="columns"
          :rowOptList="rowOptList"
          :searchParams="{}"
          :listApi="listApi"
          :deleteParam="deleteParam"
          :rowSelection="false"
        >
        </x-tabula>

      </div>
    </div>

    <!--编辑功能的弹窗-->
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="submitForm"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      destroyOnClose
      okText="确认"
      cancelText="取消"
      :width="900"
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <x-addEdit
        formType="modal"
        :isSubmitBtn="false"
        :itemLayout="$store.state.modal_ItemLayout"
        :reqLoading="btnLoading"
        :formList="functionList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="editParam"
        :detailParam="detailParam"
        >
        <template slot="int" slot-scope="{formItem}">
          <a-form-item v-if="formItem.show" class="btn-gropu-gps" :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-input-group compact>
              <a-form-item v-for="(item, index) of formItem.subList" :key="index">
                <a-input v-decorator="item.props" :placeholder="item.placeholder"/>
              </a-form-item>
            </a-input-group>
          </a-form-item>
        </template>

        <template slot="enum" slot-scope="{formItem}">
          <a-form-item class="enum-list" v-if="formItem.show" :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <div v-for="(item, index) of formItem.subList" :key="index">
              <div v-for="(el, order) of item.list" :key="order">
                <a-form-item :label="el.label" v-bind="{ labelCol: { span: 20 }, wrapperCol: { span: 24}}">
                  <a-input v-decorator="el.props" :placeholder="el.placeholder"/>
                </a-form-item>
              </div>
              <span class="delete" v-if="item.deleteBtn" @click="deleteHandle(formItem.subList, index)">
                <a-icon type="close-circle" />
              </span>
            </div>
            <a-button class="add" @click="enumAdd" type="dashed" icon="plus" block>添加</a-button>
          </a-form-item>
        </template>

        <template slot="bool" slot-scope="{formItem}">
          <a-form-item v-if="formItem.show" :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <template v-for="(item, index) of formItem.subList">
              <a-form-item :label="item.label" :key="index" v-bind="{ labelCol: { span: 4 }, wrapperCol: { span: 12 } }">
                <a-input v-decorator="item.props" :placeholder="item.placeholder"/>
              </a-form-item>
            </template>
          </a-form-item>
        </template>

        <template slot="defaultVal" slot-scope="{formItem}">
          <a-form-item :label="formItem.label" v-bind="$store.state.modal_ItemLayout">
            <a-input v-decorator="formItem.props" :placeholder="formItem.placeholder"/>
          </a-form-item>
        </template>
      </x-addEdit>
    </a-modal>
  </div>
</template>
<script>
import { fetchSelect } from '../../../utils/mixins';

let functionDecorator = {
  title: {
    rules: [{required: true, message: '请输入功能名称'}]
  },
  unique: {
    rules: [{required: true, message: '请输入标识符'}]
  },
  val_type: {
    rules: [{required: true, message: '请选择数据类型'}]
  },
  open: {
    rules: []
  },
  close: {
    rules: []
  },
  label: {
    rules: [{required: true, message: '请输入名称'}]
  },
  value: {
    rules: [{required: true, message: '请输入值'}]
  },
  val: {
    rules: [{required: true, message: '请输入默认值'}]
  },
  description: {
    rules: [{required: true, message: '请输入描述'}]
  },
  status: {
    initialValue: 1,
    rules: [{required: true, message: '请选择状态'}]
  }
};
export default {
  mixins: [fetchSelect],
  name: 'editProduct',
  data () {
    return {
      getList: {
        reqList: false
      },
      actionId: '',
      modalTitle: '',
      btnLoading: { loading: false },
      visible: false,
      isSubmit: false,
      columns: [
        { title: '功能名称', dataIndex: 'title', align: 'left', width: '' },
        { title: '标识符', dataIndex: 'unique', align: 'left', width: '' },
        { title: '数据类型', dataIndex: 'val_type', align: 'left', width: '' },
        { title: '状态', dataIndex: 'status_desc', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      rowOptList: [
        {text: '', customRender: true, handle: (row) => this.changeStatus(row), key: 'status'},
        {text: '编辑', handle: (row) => this.editFun(row.action_id), key: 'edit'},
        {text: '删除', handle: (row) => this.$refs.table.showDeleteConfirm(row), key: 'delete'}
      ],
      tableData: [],
      listApi: {
        url: `/product/action/${this.$route.query.id}`,
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/product/action',
        param: {pk_key: 'action_id', pk_val: ''},
        title: '产品功能',
        key: 'title'
      },
      functionList: [
        {
          label: '功能名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入功能名称',
          disabled: false,
          props: ['title', functionDecorator.title]
        },
        {
          label: '标识符',
          inputType: 'input',
          options: [],
          placeholder: '请输入标识符',
          disabled: false,
          props: ['unique', functionDecorator.unique]
        },
        {
          label: '数据类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择数据类型',
          handle: this.dataTypeChange,
          disabled: false,
          props: ['val_type', functionDecorator.val_type]
        },
        {
          slot: 'int',
          show: false,
          label: '范围',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '最小值',
              props: ['min', {
                rules: [{required: true, message: '请输入最小值'}]
              }]
            },
            {
              inputType: 'input',
              placeholder: '最大值',
              props: ['max', {
                rules: [{required: true, message: '请输入最大值'}]
              }]
            }
          ]
        },
        {
          slot: 'enum',
          show: false,
          label: '枚举',
          inputType: 'input',
          subList: [
            {
              deleteBtn: true,
              list: [
                {
                  label: '参数名',
                  inputType: 'input',
                  placeholder: '参数名',
                  props: ['label_1', functionDecorator.label]
                },
                {
                  label: '参数值',
                  inputType: 'input',
                  placeholder: '参数值',
                  props: ['value_1', functionDecorator.value]
                }
              ]
            }
          ]
        },
        {
          slot: 'bool',
          show: false,
          label: '布尔值',
          inputType: 'input',
          subList: [
            {
              label: '开 - ',
              inputType: 'input',
              placeholder: '',
              props: ['open', functionDecorator.open]
            },
            {
              label: '关 - ',
              inputType: 'input',
              placeholder: '',
              props: ['close', functionDecorator.close]
            }
          ]
        },
        {
          slot: 'defaultVal',
          label: '默认值',
          inputType: 'input',
          options: [],
          placeholder: '请输入默认值',
          props: ['val', functionDecorator.val]
        },
        {
          label: '描述',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入描述',
          props: ['description', functionDecorator.description]
        }
      ],
      formKey: {
        title: '',
        unique: '',
        val_type: '',
        min: '',
        max: '',
        open: '',
        close: '',
        label: '',
        value: '',
        val: '',
        description: '',
        status: ''
      },
      addParam: {
        url: `/product/action/add/${this.$route.query.id}`,
        reqHandle: this.reqHandle,
        resHandle: this.addEditResHandle
      },
      editParam: {
        url: `/product/action/edit/${this.$route.query.id}/`,
        resHandle: this.addEditResHandle
      },
      detailParam: {
        url: `/product/action/${this.$route.query.id}/`,
        resHandle: this.detailResHandle
      }
    };
  },
  mounted () {},
  methods: {
    submitForm () {
      this.$refs.addEdit.handleSubmit();
    },
    /* 状态切换 */
    changeStatus (row) {
      this.$put({
        url: `/product/action/edit/${this.$route.query.id}/${row.action_id}`,
        params: { status: row.status === 1 ? 0 : 1 }
      }).then((res) => {
        this.$message.success('状态切换成功');
        this.$refs.table.getTableList();
      });
    },
    // 添加编辑返回处理
    addEditResHandle () {
      this.visible = false;
      this.getList.reqList = true;
    },
    /* 根据数据类型切换输入框 */
    dataTypeChange (val) {
      let slot;
      val === 'float' ? slot = 'int' : slot = val;
      this.functionList.forEach((el) => {
        if (el.slot && el.slot === slot) {
          let rule;
          if (['int', 'float', 'bool'].some(item => item === val)) {
            if (val === 'int') {
              rule = [
                {required: true, message: '请输入值'},
                { pattern: /^\d*$/, message: '请输入整数' }
              ];
            } else if (val === 'float') {
              rule = [
                {required: true, message: '请输入值'},
                { pattern: /^\d+(\.\d{0,3})?$/, message: '请输入小数或整数，最多三位小数' }
              ];
            } else if (val === 'bool') {
              rule = [
                {required: true, message: '请输入值'},
                { pattern: /^\w*$/, message: '请输入数字、字母' }
              ];
            }
            let subList = el.subList;
            subList[0].props[1].rules = rule;
            subList[1].props[1].rules = rule;
          }
        }

        el.slot === slot ? el.show = true : el.show = false;
      });
    },
    /* 打开弹窗 */
    openAddModal () {
      this.visible = true;
      this.modalTitle = '添加功能';
      this.$nextTick(() => {
        this.disableForm(false);
        this.deviceManageSelect([{index: 2, key: 'data_type', scope: 'functionList'}]);
      });
    },
    /* 编辑功能 */
    editFun (id) {
      this.visible = true;
      this.modalTitle = '编辑功能';
      this.$nextTick(() => {
        this.disableForm(true);
        this.$refs.addEdit.routeQuery = id;
        this.$refs.addEdit.getDetail();
      });
    },
    disableForm (parm) {
      this.functionList.forEach((el, index) => {
        let indexArr = [0, 1, 2];
        if (indexArr.some(item => item === index)) {
          el.disabled = parm;
        }
      });
    },
    /* 添加枚举类型项 */
    enumAdd () {
      let label = '参数名';
      let label2 = '参数值';
      let inputType = 'input';
      this.functionList.forEach((el) => {
        if (el.slot && el.slot === 'enum') {
          el.subList[0].deleteBtn = true;
          let len = el.subList.length;
          el.subList.push({
            deleteBtn: true,
            list: [
              {
                label: label,
                inputType: inputType,
                placeholder: label,
                props: [[`label_${len + 1}`], functionDecorator.label]
              },
              {
                label: label2,
                inputType: inputType,
                placeholder: label2,
                props: [[`value_${len + 1}`], functionDecorator.value]
              }
            ]
          });
        }
      });
    },
    /* 删除枚举类型项 */
    deleteHandle (list, index) {
      if (list.length > 2) {
        list.splice(index, 1);
      } else if (list.length === 2) {
        list[0].deleteBtn = false;
        list.splice(index, 1);
      }
    },
    /* 表单提交前处理数据 */
    handleData (values) {
      let valType = values.val_type;
      let enumValArr = [];
      if (valType === 'enum') {
        let len;
        this.functionList.forEach((el) => {
          if (el.slot === 'enum') {
            len = el.subList.length;
          }
        });
        let enumArr = [];
        for (let i = 0; i < len; i++) {
          let obj = {};
          for (let item in values) {
            let itemArr = item.split('_');
            if (itemArr.length === 2 && parseInt(itemArr[1]) === i + 1) {
              if (item.indexOf('label') > -1) {
                obj[values[item]] = '';
              }
              if (item.indexOf('value') > -1) {
                enumValArr.push(values[item]);
                for (let part in obj) {
                  obj[part] = values[item];
                }
              }
            }
          }
          enumArr.push(obj);
        }
        values.val_content = JSON.stringify(enumArr);
      } else if (valType === 'int' || valType === 'float') {
        let rangeObj = { min: '', max: '' };
        for (let item in rangeObj) {
          if (values.hasOwnProperty(item)) {
            rangeObj[item] = values[item];
          }
        }
        values.val_content = JSON.stringify(rangeObj);
      } else if (valType === 'bool') {
        let boolObj = { open: '', close: '' };
        for (let item in boolObj) {
          if (values.hasOwnProperty(item)) {
            boolObj[item] = values[item];
          }
        }
        values.val_content = JSON.stringify(boolObj);
      }

      // 判断默认值范围
      let defaultVal = values.val;
      let content = JSON.parse(values.val_content);
      if (valType === 'int' || valType === 'float') {
        let min, max;
        for (let el in content) {
          if (el === 'min') {
            min = parseFloat(content[el]);
          } else if (el === 'max') {
            max = parseFloat(content[el]);
          }
        }
        if (parseFloat(defaultVal) < min || parseFloat(defaultVal) > max) {
          this.$message.error('默认值需在范围内');
          return;
        }
      } else {
        let hasSomeVal;
        if (Array.isArray(content)) {
          hasSomeVal = enumValArr.some((el) => el === defaultVal);
        } else {
          let rangeVal = [];
          for (let item in content) {
            rangeVal.push(content[item]);
          }
          hasSomeVal = rangeVal.some((el) => el === defaultVal);
        }
        if (!hasSomeVal) {
          this.$message.error('默认值需在范围内');
          return;
        }
      }
      return values;
    },
    addResHandle (res) {
      return res;
    },
    reqHandle (param) {
      let resParam = this.handleData(param);
      if (resParam) {
        return resParam;
      }
    },
    detailResHandle (data) {
      let formValues = {};
      for (let item in data) {
        if (this.formKey.hasOwnProperty(item)) {
          formValues[item] = data[item];
        }
      }
      if (data.val_type) {
        this.deviceManageSelect([{index: 2, key: 'data_type', scope: 'functionList'}]);
        this.dataTypeChange(data.val_type);
        let content;
        if (data.val_content) {
          content = JSON.parse(data.val_content);
        }
        if (typeof content === 'object') {
          if (!Array.isArray(content)) {
            formValues = Object.assign(formValues, content);
          } else {
            let obj = {};
            let arr = [];
            content.forEach((el, index) => {
              for (let i in el) { // 获取枚举列表的值
                obj[`value_${index + 1}`] = el[i];
                obj[`label_${index + 1}`] = i;
              }
              arr.push({ // 拼接formList列表
                deleteBtn: true,
                list: [
                  {
                    label: '参数名',
                    inputType: 'input',
                    placeholder: '参数名',
                    props: [`label_${index + 1}`]
                  },
                  {
                    label: '参数值',
                    inputType: 'input',
                    placeholder: '参数值',
                    props: [`value_${index + 1}`]
                  }
                ]
              });
            });
            this.functionList.forEach((el) => {
              if (el.slot === 'enum') {
                el.subList = arr;
              }
            });
            formValues = Object.assign(formValues, obj);
          }
        }
      }
      this.$nextTick(() => {
        // this.formData = formValues;
      });
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
